import { SparkleIcon } from "@phosphor-icons/react";
import { useI18N } from "common/hooks";
import { cn } from "@/lib/utils";

/** Marks a group of tags as machine-written rather than recorded on site. */
export default function SmartTaggingPanel({
  children,
  className,
  onDark = false,
}: {
  children: React.ReactNode;
  className?: string;
  /**
   * For the photo lightbox, which is black in both themes. The themed tokens
   * resolve to a near-white panel in light mode, so its light text would be
   * illegible; these fixed dark-surface colours keep the same look on black.
   */
  onDark?: boolean;
}) {
  const i18n = useI18N();

  return (
    <div
      className={cn(
        "flex flex-col gap-3 p-3 rounded-lg border",
        onDark
          ? "bg-primary-900 border-primary-700"
          : "bg-bg-brand-tertiary-default border-border-token-brand-minimal",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <SparkleIcon
          size={16}
          weight="fill"
          aria-hidden="true"
          className={cn(
            "shrink-0",
            onDark ? "text-primary-300" : "text-fg-brand-subtle",
          )}
        />
        <span
          className={cn(
            "label-m-semibold",
            onDark ? "text-primary-300" : "text-fg-brand-subtle",
          )}
        >
          {i18n.get("smartTagging")}
        </span>
        <span
          className={cn(
            "rounded-full border px-2 py-0.5 label-s-medium",
            onDark
              ? "border-primary-700 bg-primary-800 text-primary-100"
              : "border-border-token-brand-subtle bg-bg-brand-secondary-default text-fg-neutral-strong",
          )}
        >
          {i18n.get("beta")}
        </span>
      </div>
      {children}
    </div>
  );
}
